/**
 * Created By Alon Yampolski on 23/1/19
 */

import { createSelector, MemoizedSelector } from '@ngrx/store';
import { State } from '../state';
import { BpmnDeploymentIdentifier } from '@ispm-shared/modules/bpmn';
import { selectBpmnModelerState } from '@ispm-client/modules/bpmn-modeler/store/selectors/bpmn-modeler-state.selector';

const getBpmnIdentifier = (state: State): BpmnDeploymentIdentifier => state.bpmnIdentifier;

export const selectBpmnIdentifier: MemoizedSelector<object, BpmnDeploymentIdentifier> = createSelector(selectBpmnModelerState, getBpmnIdentifier);
